<template>
  <section>
    <h2>Skills</h2>
    <div class="flex-wrapper">
      <div
        @click="currentTabComponent = 'Tab1'"
        class="skill__tile skill__tile--large"
      >
        <SvgIconDesign class="skill__logo--large"></SvgIconDesign>
        <p class="skill__name">Graphic Design</p>
      </div>

      <div
        @click="currentTabComponent = 'Tab2'"
        class="skill__tile skill__tile--large"
      >
        <SvgIconUi class="skill__logo--large"></SvgIconUi>
        <p class="skill__name">UI Design</p>
        <!-- <p class="skill__proficiency">{{ skill.proficiency }}</p> -->
      </div>

      <div
        @click="currentTabComponent = 'Tab3'"
        class="skill__tile skill__tile--large"
      >
        <SvgIconWeb class="skill__logo--large"></SvgIconWeb>
        <p class="skill__name">Web Development</p>
      </div>
      <div
        @click="currentTabComponent = 'Tab4'"
        class="skill__tile skill__tile--large"
      >
        <SvgIconPerf class="skill__logo--large"></SvgIconPerf>
        <p class="skill__name">Perf & Optimization</p>
      </div>
      <div
        @click="currentTabComponent = 'Tab5'"
        class="skill__tile skill__tile--large"
      >
        <SvgIconEmail class="skill__logo--large"></SvgIconEmail>
        <p class="skill__name">Email Development</p>
      </div>
      <keep-alive>
        <component :is="currentTabComponent"></component>
      </keep-alive>
    </div>

    <!-- <div class="flex-wrapper">
      <div
        v-for="(skill, i) in skills"
        v-bind:key="i"
        class="skill__tile skill__tile--large"
        :class="{ active: i === activeItem }"
        @click="selectItem(i)"
      >
        <img class="skill__logo--large" v-bind:src="skill.logo" />
        <p class="skill__name">{{ skill.name }}</p>
      </div>
      <div v-for="skill in skills" v-bind:key="skill.id">
        <p
          :id="skill.name.toLowerCase().replace(/\s/g, '-')"
          class="skill__desc"
        >
          {{ skill.desc }}
        </p>
      </div>
    </div> -->
  </section>
  <section>
    <h2>Toolbelt</h2>
    <div id="skills" class="skills">
      <p class="skill__section__title">Design: UI/UX</p>
      <div class="skill__section">
        <div
          v-for="uiSoftware in uiSoftwares"
          v-bind:key="uiSoftware.id"
          class="skill__tile"
        >
          <img v-bind:src="uiSoftware.logo" class="skill__logo" />
          <p class="software__name">{{ uiSoftware.name }}</p>
          <p class="software__proficiency">{{ uiSoftware.proficiency }}</p>
          <div class="skill__progress__bar">
            <span
              class="skill__progress__indicator"
              :style="{ width: uiSoftware.proficiency }"
            ></span>
          </div>
        </div>
      </div>
      <p class="skill__section__title">Design: Graphic & Video</p>
      <div class="skill__section">
        <div
          v-for="designSoftware in designSoftwares"
          v-bind:key="designSoftware.id"
          class="skill__tile"
        >
          <img class="skill__logo" v-bind:src="designSoftware.logo" />
          <p class="software__name">{{ designSoftware.name }}</p>
          <p class="software__proficiency">
            {{ designSoftware.proficiency }}
          </p>
          <div class="skill__progress__bar">
            <span
              class="skill__progress__indicator"
              :style="{ width: designSoftware.proficiency }"
            ></span>
          </div>
        </div>
      </div>
      <p class="skill__section__title">Code Development</p>
      <div class="skill__section">
        <div
          v-for="language in languages"
          v-bind:key="language.id"
          class="skill__tile"
        >
          <img class="skill__logo" v-bind:src="language.logo" />
          <p class="skill__name">{{ language.name }}</p>
          <p class="skill__proficiency">{{ language.proficiency }}</p>
          <div class="skill__progress__bar">
            <span
              class="skill__progress__indicator"
              :style="{ width: language.proficiency }"
            ></span>
          </div>
        </div>
      </div>

      <p class="skill__section__title">QA & Testing</p>
      <div class="skill__section skill__checks">
        <div
          v-for="testingSoftware in testingSoftwares"
          v-bind:key="testingSoftware.id"
          class="skill__tile"
        >
          <img class="skill__logo" v-bind:src="testingSoftware.logo" />
          <p class="software__name">{{ testingSoftware.name }}</p>
          <SvgIconSkillCheck></SvgIconSkillCheck>
        </div>
      </div>
      <p class="skill__section__title">Productivity</p>
      <div class="skill__section skill__checks">
        <div
          v-for="productivitySoftware in productivitySoftwares"
          v-bind:key="productivitySoftware.id"
          class="skill__tile"
        >
          <img v-bind:src="productivitySoftware.logo" class="skill__logo" />
          <p class="software__name">{{ productivitySoftware.name }}</p>
          <SvgIconSkillCheck class="skill__icon--check"></SvgIconSkillCheck>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    jobz,
    uiSoftwares,
    designSoftwares,
    testingSoftwares,
    productivitySoftwares,
    languages,
    skills,
  } from "../../data.js"
  import anime from "animejs"
  import apexchart from "vue3-apexcharts"
  import SvgIconDesign from "@/components/svg/SvgIconDesign.vue"
  import SvgIconSkillCheck from "@/components/svg/SvgIconSkillCheck.vue"
  import SvgIconUi from "@/components/svg/SvgIconUi.vue"
  import SvgIconPerf from "@/components/svg/SvgIconPerf.vue"
  import SvgIconWeb from "@/components/svg/SvgIconWeb.vue"
  import SvgIconEmail from "@/components/svg/SvgIconEmail.vue"
  import Tab1 from "@/components/tabs/Tab1.vue"
  import Tab2 from "@/components/tabs/Tab2.vue"
  import Tab3 from "@/components/tabs/Tab3.vue"
  import Tab4 from "@/components/tabs/Tab4.vue"
  import Tab5 from "@/components/tabs/Tab5.vue"

  export default {
    name: "Skills",
    components: {
      apexchart,
      SvgIconSkillCheck,
      SvgIconDesign,
      SvgIconUi,
      SvgIconPerf,
      SvgIconWeb,
      SvgIconEmail,
      Tab1,
      Tab2,
      Tab3,
      Tab4,
      Tab5,
    },
    data() {
      return {
        jobz,
        uiSoftwares,
        designSoftwares,
        testingSoftwares,
        productivitySoftwares,
        languages,
        skills,
        headline: "Why are you here?",
        activeItem: false,
        currentTabComponent: "Tab1",
      }
    },
    methods: {
      selectItem(i) {
        // this.isActive = !this.isActive
        this.activeItem = i
      },
    },
    mounted() {
      this.$nextTick(function() {
        // Code that will run only after the entire view has been rendered
        anime({
          // skill progres bars
          targets: ".skill__progress__indicator",
          width: 0,
          easing: "easeInOutQuad",
          direction: "alternate",
        })
      })
    },
  }
</script>

<style lang="scss"></style>
